import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../header/Header";
import LinkBased from "./component/LinkBased";
import AssociationBased from "./component/AssociationBased";
import CategoryBased from "./component/CategoryBased";

const CampaignDetails = () => {
  const location = useLocation();
  const state = location.state || {};
  const type = state.type || "Association";
  const id = state.id || "Create";

  const headerTitle = id === "Create" ? "Create Campaign" : "Edit Campaign";
  return (
    <div className="campaign-details-page">
      <Header title={headerTitle} back={() => window.history.back()} />
      {/* "Association based" */}
      <section className="campaign-details-container">
        {type === "Link" && <LinkBased id={id} />}
        {/* {type === "Category" && <CategoryBased id={id} />} */}
        {/* {type === "Association" && <AssociationBased id={id} />} */}
      </section>
    </div>
  );
};

export default CampaignDetails;
